
(function($) {

	/// ==================== 
	/// Global vars  here :)
	/// ====================
	//var projectLoader = $('.project-loader');
	var wWidth = $(window).width(),
	hHeight = $(window).height(),
	accordianItem = $('.accordian-parent'),
	cart = $('ul#cart-inner'),
	selectBox = $("#register").find('.select-wrapper select.form-control'),
	subNavButton = $('#profile-sub-nav a'),
	clickedRegisters = $('.register-tick.active'),
	tickButton = $('.tick-button'),
	parentC = $('.large-video'),
	slider = $('#gallery-slider .block .wrap .inner'),
	object = $(".item");

	var emailField = $('input[type="email"]');

	$.each( $(emailField) , function () {
		$(this).attr('placeholder','Email Address');
	});

	$('.bg-large-fixed').royalSlider({
	    imageScaleMode: 'fill',
	    autoScaleSlider: false,
	    autoHeight: false,
	    imageAlignCenter: true,
	    slidesSpacing: 0,
	    loop: true,
	    fadeinLoadedSlide: true,
	    transitionType:'fade',
	    autoPlay: {
    		// autoplay options go gere
    		enabled: true,
    		pauseOnHover: true
    	}
	});


// check if browser safari and do validation
var ua = navigator.userAgent.toLowerCase(); 
if (ua.indexOf('safari') != -1) { 
  if (ua.indexOf('chrome') > -1) {

  } else {
    var formH = document.getElementById('search-form'); // form has to have ID: <form id="formID">
	formH.noValidate = true;
	formH.addEventListener('submit', function(event) { // listen for form submitting
		if (!event.target.checkValidity()) {
		    event.preventDefault(); // dismiss the default functionality
		    $('.error').html('<p style="color:red;"></p>');
		}
	}, false);
  }
}


var resize = function() {
    $('.bg-large-fixed').css({
        width: $(window).width(),
        height: $(window).height()
    });
    $.each( $('.rsImg') , function () {
		$(this).attr('data-rsw',$(window).width());
		$(this).attr('data-rsh',$(window).height());
	});
};

$(window).on('resize', resize);
resize();

	$('ul.up-share').upShare();

	// set to the collection page

		var ias = jQuery.ias({
		  container:  "#collection-entries .inner",
		  item:       ".collection-item",
		  pagination: ".pagination",
		  next:       "a.next-pagination"
		});

		ias.extension(new IASSpinnerExtension({
			html: '<div style="text-align: center;width: 100%;clear: both;" class="loader-inner ball-pulse"></div>',
		}));            
		// shows a spinner (a.k.a. loader)
		// shows a trigger after page 3
		ias.extension(new IASNoneLeftExtension({
		  text: ''
		}));


if(window.location.pathname == '/users/favourites') {
	jQuery.ias().unbind();
}

$(function() {
	$.each($('#address p a'), function() {
	  $(this).wrapInner('<span class="inline-line"></span>');
	})
});

FastClick.attach(document.body);



	var createLoaders = function(){
		var divs = {
		    'ball-pulse': 3,
		    'ball-grid-pulse': 9,
		    'ball-clip-rotate': 1,
		    'ball-clip-rotate-pulse': 2,
		    'square-spin': 1,
		    'ball-clip-rotate-multiple': 2,
		    'ball-pulse-rise': 5,
		    'ball-rotate': 1,
		    'cube-transition': 2,
		    'ball-zig-zag': 2,
		    'ball-zig-zag-deflect': 2,
		    'ball-triangle-path': 3,
		    'ball-scale': 1,
		    'line-scale': 5,
		    'line-scale-party': 4,
		    'ball-scale-multiple': 3,
		    'ball-pulse-sync': 3,
		    'ball-beat': 3,
		    'line-scale-pulse-out': 5,
		    'line-scale-pulse-out-rapid': 5,
		    'ball-scale-ripple': 1,
		    'ball-scale-ripple-multiple': 3,
		    'ball-spin-fade-loader': 8,
		    'line-spin-fade-loader': 8,
		    'triangle-skew-spin': 1,
		    'pacman': 5,
		    'ball-grid-beat': 9,
		    'semi-circle-spin': 1,
		    'ball-scale-random': 3
		  };

		  var addDivs = function(n) {
		    var arr = [];
		    for (i = 1; i <= n; i++) {
		      arr.push('<div></div>');
		    }
		    return arr;
		  };

		  $.fn.loaders = function() {
		    return this.each(function() {
		      var elem = $(this);
		      $.each(divs, function(key, value) {
		        if (elem.hasClass(key))
		          elem.html(addDivs(value))
		      })
		    });
		  };

		  $(function() {
		    $.each(divs, function(key, value) {
		      $('.loader-inner.' + key).html(addDivs(value));
		    })
		  });

		};

	var widthCheck = function() {

	  var $window = $(window);
	  var w = $window.width();
	  var h = $window.height();
	  var elSlider = $('#gallery-slider .block .wrap .inner').outerHeight(true);

		  if (w <= 667) {

		  	$('body').addClass('menu-closed');
		  	$('#site-navigation').addClass('mobile');
		  	$('.recently-viewed-entries').addClass('mobile');
		  	$('.account-wrap p').find('br').remove();

		  	
		  } else if (w <= 768) {

		  	var h = $window.height()/2;

	        // $("#gallery-slider .slick-slide").css({
	        // 	"height": elSlider,
	        // 	"width": w
	        // });

		  } else {
		  	$('body').addClass('menu-closed');
	        var windowsize = $window.height();
	        var footerHeight = $('footer').outerHeight();
	        var top = $('header').outerHeight();
	        var total = footerHeight + top;
	        var remainHeight = parseInt('22');
	        $(".no-results").css({"height": $window.height() - total, "width": $window.width() });
	        $('#gallery-slider').css({"height": $window.height(), "width": $window.width() });
	        // $("#gallery-slider .slick-slide, #gallery-slider .slick-slide").css({
	        // 	"height": elSlider
	        // });
	        $('#slick-slider').addClass('not--mobile');

		  }

	};

	$(window).on( 'resize', function () {
		widthCheck();
	}).resize();

	var initSliders = function() {
		$('#slick-slider').on('init', function(event, slick, currentSlide, nextSlide){
		  var pagination = $(this).find('.slick-dots'),
		  parent = $(this);
		  parent.append(pagination);
		});
		$('#slick-slider').on('breakpoint', function(event, slick, breakpoint){
		  $('#slick-slider').slick('setPosition');
		}); 



		$('#slick-slider').slick({
			slidesToShow: 1,
		  	slidesToScroll: 1,
		  	speed: 400,
		  	useTransform: true,
		  	easing: 'ease-in-out',
		    dots: true,
		    adaptiveHeight: true,
		    infinite: true,
		    centerMode: true,
		  	focusOnSelect: true,
		    fade: true,
		    asNavFor: ['.slider-nav','#gallery-slider .block .wrap .inner'],
		    prevArrow: '.prev-arrow-slider',
		    nextArrow: '.next-arrow-slider',
		    responsive: [
			    {
			        breakpoint: 980,
			        settings: {
			          variableWidth: false
			        }
			    },

			    {
			        breakpoint: 768,
			        settings: {
			          variableWidth: true
			        }
			    },
			    {
			        breakpoint: 480,
			        settings: {
			          variableWidth: false,
			          dots: true
			        }
			    }
		    ]
		});




	var beforePrint = function() {
        $('#slick-slider').slick('setPosition');
    };
    var afterPrint = function() {
        $('#slick-slider').slick('setPosition');
    };

    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(function(mql) {
            if (mql.matches) {
                beforePrint();
            } else {
                afterPrint();
            }
        });
    }

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;




		$('#slick-slider').slick('setPosition');

		$('#gallery-slider .block .wrap .inner').slick({
			slidesToShow: 1,
		  	slidesToScroll: 1,
		  	speed: 400,
		  	useTransform: true,
		  	easing: 'ease-in-out',
		    dots: false,
		    infinite: true,
		    centerMode: true,
		  	focusOnSelect: true,
		    fade: true,
		    prevArrow: '.prev-slider',
		    nextArrow: '.next-slider',
		    responsive: [
			    {
			        breakpoint: 980,
			        settings: {
			          variableWidth: false
			        }
			    },
			    {
			        breakpoint: 768,
			        settings: {
			          variableWidth: false
			        }
			    },
			    {
			        breakpoint: 480,
			        settings: {
			          variableWidth: false
			        }
			    }
		    ]
		});

		$('.slider-nav').slick({
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  speed: 250,
		  asNavFor: ['#slick-slider','#gallery-slider .block .wrap .inner'],
		  accessibility: false,
		  useTransform: true,
		  easing: 'ease-in-out',
		  dots: false,
		  arrows: false,
		  centerMode: false,
		  focusOnSelect: true,
		  prevArrow: '.prev-arrow-slider',
		  nextArrow: '.next-arrow-slider',
		  responsive: [
			    {
			        breakpoint: 980,
			        settings: {
			          variableWidth: true
			        }
			    },
			    {
			        breakpoint: 769,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 3,
			          slidesToScroll: 1
			        }
			    },
			    {
			        breakpoint: 667,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 2
			        }
			    },
			    {
			        breakpoint: 480,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 1
			        }
			    }
		    ]
		});
		$('.related-slider').slick({
		  dots: false,
		  slidesToShow: 4,
		  speed: 600,
		  slidesToScroll: 4,
		  infinite: true,
		  variableWidth: false,
		  focusOnSelect: true,
		  useTransform: true,
		  easing: 'ease-in-out',
		  prevArrow: '.prev-arrow-slider-related',
		  nextArrow: '.next-arrow-slider-related',
		  responsive: [
			    {
			        breakpoint: 980,
			        settings: {
			          variableWidth: true
			        }
			    },
			    {
			        breakpoint: 769,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 3,
			          slidesToScroll: 1
			        }
			    },
			    {
			        breakpoint: 667,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 2,
			          slidesToScroll: 1
			        }
			    },
			    {
			        breakpoint: 480,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 2,
			          slidesToScroll: 1
			        }
			    }
		    ]
		});

		$('.recently-viewed-slider').slick({
		  dots: false,
		  slidesToShow: 4,
		  speed: 600,
		  slidesToScroll: 4,
		  infinite: true,
		  useTransform: true,
		  easing: 'ease-in-out',
  		  variableWidth: false,
		  focusOnSelect: true,
		  prevArrow: '.prev-arrow-slider-recent',
		  nextArrow: '.next-arrow-slider-recent',
		  responsive: [
			    {
			        breakpoint: 980,
			        settings: {
			          variableWidth: true
			        }
			    },
			    {
			        breakpoint: 769,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 3,
			          slidesToScroll: 1
			        }
			    },
			    {
			        breakpoint: 667,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 2,
			          slidesToScroll: 1
			        }
			    },
			    {
			        breakpoint: 480,
			        settings: {
			          variableWidth: false,
			          slidesToShow: 2,
			          slidesToScroll: 1
			        }
			    }
		    ]
		});
	};
	var initMap = function() {

		L.mapbox.accessToken = 'pk.eyJ1IjoibWR1bmJhdmFuIiwiYSI6ImJkODFlZDZjMzU5N2Y0OTI5ZjcyYWMzMTdiNjY0NzhjIn0.2KGkXkLyyxtuxqj4hh_N1Q';
		// var map = new mapboxgl.Map({
		//     container: 'map',
		//     style: 'mapbox://styles/mapbox/light-v9',
		//     center: [-0.175651,51.489533],
		//     zoom: 16
		// });


		var mapTooltipsJS = L.mapbox.map('map', 'mapbox.light')
		  .setView([51.489533,-0.175651], 15);
		//L.mapbox.styleLayer('mapbox://styles/mapbox/emerald-v8').addTo(map);
		var myLayer = L.mapbox.featureLayer().addTo(mapTooltipsJS);
		var setStyle = L.mapbox.styleLayer('mapbox://styles/mdunbavan/ciu3zlx3g00nb2iolukzu92na').addTo(mapTooltipsJS);
		var ContactImage = document.getElementById('location-image');
		var imgSrc = ContactImage.src;

		var geoJson = {
		    "type": "FeatureCollection",
		    "features": [
		        {
		            "type": "Feature",
		            "properties": {
						"title": "Valerie Wade",
						"description": "Shop",
						"image": imgSrc,
						"icon": {
						  "iconUrl": "/assets/images/pin.png",
						  "iconSize": [144, 144], // size of the icon
						  "iconAnchor": [75, 70], // point of the icon which will correspond to marker's location
						  "popupAnchor": [0, -25], // point from which the popup should open relative to the iconAnchor
						  "className": "dot"
						}
		            },
		            "geometry": {
		                "type": "Point",
		                "coordinates": [
		                    -0.175651,51.489533
		                ]
		            }
		        }
		    ]
		};

		// geoJson.features.forEach(function(marker) {
		//     // create a DOM element for the marker
		//     var el = document.createElement('div');
		//     el.className = 'marker';
		//     el.style.backgroundImage = 'url(/assets/images/marker-15.svg)';
		//     el.style.width = marker.properties.iconSize[0] + 'px';
		//     el.style.height = marker.properties.iconSize[1] + 'px';
		//     el.style.backgroundRepeat = 'no-repeat';
		//     el.style.backgroundSize = 'cover';
		//     var ContactImage = document.getElementById('location-image');
		//     var imgSrc = ContactImage.src;

		//     var popupContent = '<p style="text-align: center;margin: 0;" class="h4">' + marker.properties.title + '</p><br><img alt="valerie wade shop image" src="' + imgSrc + '" /><br><p style="text-align: center;margin: 10px 0;" class="h4">' + marker.properties.description + '</p>';

		//     // add marker to map
		//     new mapboxgl.Marker(el, {offset: [-marker.properties.iconSize[0] / 2, -marker.properties.iconSize[1] / 2]})
		//         .setLngLat(marker.geometry.coordinates)
		//         .addTo(map);

		//     map.on('click', function (e) {
		// 	    var popup = new mapboxgl.Popup({closeOnClick: true})
		// 	    .setLngLat(marker.geometry.coordinates)
		// 	    .setHTML(popupContent)
		// 	    .addTo(map);
		// 	});

		    
		// });

		// Set a custom icon on each marker based on feature properties.
		myLayer.on('layeradd', function(e) {
		  var marker = e.layer,
		    feature = marker.feature;
		  marker.setIcon(L.icon(feature.properties.icon));
		  var content = '<h2 class="light uppercase" style="color:#5d89b4;">'+ feature.properties.title+'<\/h2>' + '<img src="'+feature.properties.image+'" alt="">';
		  marker.bindPopup(content);
		});
		myLayer.setGeoJSON(geoJson);
		mapTooltipsJS.scrollWheelZoom.disable();


	};
	var hoverCall = function(){

		// Going to do all hover functionality here for across the site
		var object = $("#instagram article");
		var thisHeight = object.innerHeight();
		$(object).find('.module').css('height',thisHeight);

		$.each( $(object) , function () {
			var a = $(this).find('.module');
			$(this).hover(function() {
			    a.addClass('on');
			}, function(){
			    a.removeClass('on');
			});
		}).resize();

		$('.mobile-cat-list__toggle').on('click',function(e){
			e.preventDefault();
			var list = $(this).next('.mobile-cat-list__children-list');
			if( list.hasClass('open') ){
				list.removeClass('open');
				$(this).attr('aria-expanded','false');
			} else {
				list.addClass('open');
				$(this).attr('aria-expanded','true');
			}
		});

		$('.recently-viewed-entries.mobile h3').on('click',function(){
			if( $(this).parent().hasClass('up') ){
				$(this).parent().removeClass('up');
				$('.recently-viewed-slider').slick('setPosition');
			} else {
			    $(this).parent().addClass('up');
			    $('.recently-viewed-slider').slick('setPosition');
			} 
		});

	};
	var openMenu = function(){
		$('body').addClass('no-scroll');	        
        $('#site-navigation').addClass('mobile');
        $('body').removeClass('menu-closed');
        $('body').addClass('menu-open');       
        $('#menu-button').addClass('selected');

        window.setTimeout(function(){
  			$('.menu-the-menu-container ul li').addClass('is--menu-active');
  		},750);
	};
	var closeMenu = function(){
		$('body').removeClass('no-scroll');
        $('#menu-button').removeClass('selected');
        $('body').addClass('menu-closed');
        $('body').removeClass('menu-open');
  		$('.menu-the-menu-container ul li').removeClass('is--menu-active');
	};
	var menuOpen = function() {

		var flag = false;
	  $('#menu-button').on('touchstart click', function(e){


	    if (!flag) {
	      flag = true;

	      setTimeout(function(){
			flag = false;
			},100);

	      if ( $('body').hasClass('menu-closed') ){

	      	openMenu();
	      	$('#mobile-navigation').removeClass('closed').addClass('open');

	      } else {
	      	
	      	closeMenu();
	      	$('#mobile-navigation').removeClass('open').addClass('closed');
	      	// cartOpen();

	      }
	    }
	    return false;
	  }).resize();

	};

	$('.has-dropdown a.is-parent').on('click',function(e){

		e.preventDefault();
		var h = $(this).parent().find('ul').outerHeight(true),
			siblings = $(this).parent().siblings();
		siblings.removeClass('active');
		if( $(this).parent().hasClass('active') ){
			$(this).parent().removeClass('active').css({
		    	'height':'40px'
		    });
		} else {
		    $(this).parent().addClass('active').css({
		    	'height':h + 30
		    });
		} 

	});

	var modalVideo = function() {

		// $.each( $('.collection-item, .collection-info') , function () {

			$('.collection-info .btn-enquire').on('click', function(e){
				console.log('clicked');

				var parentModal = $(this).parent().find('.modal');

				e.preventDefault();

				// var $this = $(this),
				//     form = $this.find('form'),
				//     mainShareurl = 'https://www.youtube.com/watch?v='+vidurl,
				//     mainShareTitle = $this.data('video-title');
				// $this.addClass('active');
				// $this.attr('data-link',mainShareurl);

				// $('.modal__iframe iframe').attr('src', 'http://www.youtube.com/embed/' + vidurl + '?autohide=1&autoplay=1&rel=0&modestbranding=1&fs=1').attr('allowfullscreen', "");
				// $('.modal .up-share .share li a').attr('href',mainShareurl);
				// $('.modal .up-share .share li a').data('title',mainShareTitle);
				parentModal.fadeIn();
				parentModal.find('.slick-arrow').hide();
				$('.modal__form').css({'visibility':'visible','zIndex':'9999999'});
				slider.css('visibility','hidden');

		  	});

			// exit the modal on click and strip the iframes url to prevent "video bleed"
			$('.close').on('click', function(){
				$(this).parent().fadeOut();
			});

		// });


	};


	var closeModal = function(){
		$('.close').on('click', function(){
			$(this).parent().fadeOut();
			iframeWrap = $('.iframe-wrapper');
			iframeWrap.html(iframeWrap.html());
		});
	}


	var videoOpen = function(){
		$('.btn-video').on('click', function(e){
			e.preventDefault();
			$('.modal--video').fadeIn();
		});
	}

	var enquireOpen = function(){
		$('.btn-enquire').on('click', function(e){
			e.preventDefault();
			$('.modal--enquire').fadeIn();
		});
	}

	var newsletterOpen = function(){
		$('.btn-newsletter').on('click', function(e){
			e.preventDefault();
			$('.modal--newsletter').fadeIn();
		});
	}

	var scrollShow = function(){

		var items = $('.super-header');

		items.each(function(){
			if($(this).offset().top > $(window).scrollTop()+$(window).height()*0.75) {
				$(this).addClass('null');
				$('#home-slider h1.super-header').removeClass('null');
			}
		});

		$(window).on('scroll', function(){
			items.each(function(){
				if( $(this).offset().top <= $(window).scrollTop()+$(window).height()*0.75 && $(this).hasClass('null') ) {
					$(this).removeClass('null').addClass('fade-in');
				}
			});
		});

	};

    var formSend = function(){

		// The enquiry form is a Freeform form rendered with ajax:true, so Freeform
		// handles the actual submission itself. We only listen to its ajax events
		// to drive the theme's loader/message UI - we must not submit it ourselves,
		// or the form gets posted twice (and the admin notification sent twice).
		var enquireFormEl = document.querySelector('.modal__form:not(.modal__form--newsletter) form');

		if (enquireFormEl) {
			var $enquireForm = $(enquireFormEl);
			var formMessages = $('#form-messages');

			enquireFormEl.addEventListener('freeform-ajax-before-submit', function() {
				$enquireForm.find('.buttons').find('button').hide();
				$enquireForm.find('.buttons').append('<div class="loader-inner ball-pulse"></div>');
				createLoaders();
			});

			enquireFormEl.addEventListener('freeform-ajax-success', function() {
				$(formMessages).removeClass('error');
				$(formMessages).addClass('success');
				$(formMessages).addClass('animated');
				$(formMessages).addClass('fadeIn');

				$(formMessages).html('<h3 style="text-transform: none;" class="light">Thank you for your enquiry. We will be in touch shortly.</h3>');
				$enquireForm.fadeOut('slow');

				window.setTimeout(function(){
					window.location.reload(false);
				}, 3000);
			});

			enquireFormEl.addEventListener('freeform-ajax-error', function() {
				$(formMessages).removeClass('success');
				$(formMessages).addClass('error');
				$(formMessages).addClass('animated');
				$(formMessages).addClass('fadeIn');

				$enquireForm.find('.buttons').find('button').show();
				$enquireForm.find('.buttons .loader-inner').remove();
			});
		}


		$('.modal__form--newsletter form').submit(function(event){
			event.preventDefault();

			var form = $('.modal__form--newsletter form');
			var formMessages = $('.modal__form--newsletter .form-messages');

			$.post('/', $(this).serialize())
			.done( function(data) {
		
			if (!data.success)
			{
				// there was an error, do something with data

				$('.modal__form--newsletter form fieldset .form__row input').val('');
				//form.fadeOut('slow');
				$(formMessages).html('<h3 style="text-transform: none;" class="light">Sorry there was a problem.<br>'+data.message+'</h3>');
			}
			else
			{
				// Success
				// Set the message text.
				$('.modal__form--newsletter form fieldset .form__row input').val('');
				form.fadeOut('slow');
				$('.modal__form--newsletter h3').fadeOut('slow', function(){
						$(formMessages).html('<h3 style="text-transform: none;" class="light">Thank you for subscribing</h3><p>You will shortly receive an email with a confirmation link, please click that link to complete your subscription.</p>');
				});
			
				
				// form.parent().append('<p>'+data.afterSubmitText+'</p>');
				window.setTimeout(function(){
					window.location.reload(false);
					form.find('.buttons').find('button').show();
					form.find('.buttons .loader-inner').remove();
				}, 6000);
			}
		
			});
		});



    };

    var backgroundImages = function(){

		var $f = $('section').find('.image-slide');

		function recursive(i) {
		    $f.removeClass('showing').eq(i).addClass('showing');
		    setTimeout(function () {
		        recursive(++i % $f.length)
		    }, 5000);
		}

		recursive(0);


    };

    var searchOpen = function(_this){

		if( _this.parent().hasClass('open') ){
			_this.parent().removeClass('nav-item--current open');
			$('.search-bar').addClass('drawer--up').removeClass('drawer--down');
			$('.site').removeClass('open');
			$('body').css('overflow','');
		} else {
			_this.parent().addClass('open');
			$('.search-bar').addClass('drawer--down').removeClass('drawer--up');
			$('.site').addClass('open');
			$('.collection-bar').addClass('drawer--up').removeClass('drawer--down');
			$('.nav-list li a#collection-show-bar').parent().removeClass('nav-item--current');
			// set focus to search input. Had to put a delay on it so the css animation completes before assigning focus
			setTimeout(function() { $('#search-form').find('input[type="search"]').focus(); }, 1000);
		}
    };

    var collectionOpen = function(_this){

		if( _this.parent().hasClass('open') ){
			_this.parent().removeClass('nav-item--current open');
			$('.collection-bar').addClass('drawer--up').removeClass('drawer--down');
			$('h1.super-header img').fadeIn();
			$('header .mobile').fadeOut();
			$('body').css('overflow','');
			$('.site').removeClass('open');
		} else {
			_this.parent().addClass('open');
			$('.collection-bar').addClass('drawer--down').removeClass('drawer--up');
			$('.site').addClass('open');
			$('h1.super-header img').fadeOut();
			$('header .mobile').fadeIn();
			$('.search-bar').addClass('drawer--up').removeClass('drawer--down');
			$('.nav-list li a#search-bar').parent().removeClass('nav-item--current');
		}
    };

    var miscFunctions = function(element){
    	$('.nav-list li a#search-bar').on('click', function(e){
    		e.preventDefault();
    		var el = $(this);
    		searchOpen(el);
    	});
    	$('.nav-list li a#collection-show-bar').on('click', function(e){
    		e.preventDefault();
    		var el = $(this);
    		collectionOpen(el);
    	});

    	$('.site.open').on('click', function(e){



    	});

    	$('.toggle').on('click', function(e){
    		e.preventDefault();
    		if( $(this).hasClass('active') ){
    			$(this).parent().css('height','110px');
    			$(this).removeClass('active');
    			$(this).html('Filter &plus;');
    		} else {
    			$(this).addClass('active');
    			$(this).parent().css('height','auto');
    			$(this).html('Filter &minus;');
    		}
    	});
    	
    }

    $('.site').on('click', function(){
    		
    });

    var cursorMove = function() {

    	$.fn.mousetip = function(tip, x, y) {
    
		    var $this = $(this);
		    
		    $this.hover(function() {
		        
		        $(tip, this).show();
		    
		    }, function() {
		    
		        $(tip, this).hide().removeAttr('style');
		    
		    }).mousemove(function(e) {
		        
		        var mouseX = e.pageX + (x || 5);
		        var mouseY = e.pageY + (y || 5);
		    
		        $(tip, this).show().css({
		            
		            top:mouseY, left:mouseX
		            
		        });
		    });
		};

		$(function() {
			$('.image-gallery').mousetip('.tip',-200,-180);
		});

    };

    var galleryOpen = function(){

    	var $_this = $('#slick-slider.not--mobile'),
    		$_elems = $_this.find('.slick-slide'),
    		jsonObj = [],
    		gallery = [];

    	$_this.on('click','.slick-slide', function($_elems){
    		//console.log($('#gallery-slider'));
    		console.log($(this).parent().index('.slick-slide'));
			$('.modal--gallery').fadeIn().find('.slick-arrow').show();
			//$('.modal__form, .modal__form--newsletter').css('visibility','hidden');
			slider.slick('setPosition');
			slider.css('visibility','visible');
			widthCheck();		

    	});

    	$('.modal #gallery-slider').on('click',function(){
    		slider.css('visibility','hidden');
    		$('.modal__form').css('visibility','hidden');
    		$('.modal').fadeOut().find('.slick-arrow').hide();
    	});


    };


createLoaders();
scrollShow();
formSend();
miscFunctions();
widthCheck();
initSliders();
if( $('body.contact').length ){
	initMap();
}
hoverCall();
menuOpen();
//modalVideo();
backgroundImages();
cursorMove();
galleryOpen();
newsletterOpen();
enquireOpen();
videoOpen();
closeModal();

})(jQuery);